const INITIAL_STATE = {
  mySubscriptions: {},
  myAccount:{},
  // True once the signed-in user's record has arrived from the database.
  loaded: false
};

export default(state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "Navigation/NAVIGATE":
      return state;
    case "SYNC_LOCAL_FROM_GLOBAL":
      return {
        ...state,
        mySubscriptions: action.payload&&action.payload.mySubscriptions?action.payload.mySubscriptions:{},
        myAccount: action.payload&&action.payload.userAccount?action.payload.userAccount:{},
        loaded: true
      };
    case "LOGOUT_ATTEMPT":
      // Don't leave the previous user's subscriptions/profile cached after logout.
      return INITIAL_STATE;
    case "UPDATE_SUBSCRIPTION":
      let {subscriptionKey, productId, subscribedOn} = action.payload;
      return {
        ...state,
        mySubscriptions: {
          ...state.mySubscriptions,
          [subscriptionKey]:{
            ...state.mySubscriptions[subscriptionKey]||{},
            productId:productId,
            subscribedOn:subscribedOn
          } 
        }
      }
    default:
      return state;
  }
};